"use client";

import { PLAN_LIMITS, PLANS, planSupports, withinPlanLimit } from "@/lib/plans/planConfig";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export function usePlanGate(overridePlan = null) {
  const { user } = useCurrentUser();
  const currentPlan = overridePlan || user?.plan || PLANS.FREE;

  const canUse = (feature) => {
    return planSupports(currentPlan, feature);
  };

  const isWithinLimit = (feature, currentUsage) => {
    return withinPlanLimit(currentPlan, feature, currentUsage);
  };

  const getLimit = (feature) => {
    const limits = PLAN_LIMITS[currentPlan];
    return limits?.[feature] ?? 0;
  };

  const isPlan = (plan) => currentPlan === plan;
  const isFree = isPlan(PLANS.FREE);
  const isPro = isPlan(PLANS.PRO) || isPlan(PLANS.TEAM);
  const isTeam = isPlan(PLANS.TEAM);

  return {
    currentPlan,
    canUse,
    isWithinLimit,
    getLimit,
    isPlan,
    isFree,
    isPro,
    isTeam,
  };
}
